// ============================================================================
// KNAPSACK - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'knapsack',
  name: 'Knapsack',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(NW)',
    space: 'O(W)'
  },
  description: 'The 0/1 Knapsack problem: given items with weights and values, maximize the total value without exceeding the weight capacity. Uses DP to build a table where dp[i][w] represents the maximum value using first i items with capacity w.'
};
